import React from 'react';

import Circle from './Circle';

const Sumary = () => {
  return (
    <>
      <div className="row mycard mb-3">
        <div className="col col-12 py-3">
          <Circle />
        </div>
      </div>
      <div className="row mycard mb-3">
        <div className="col col-12 py-3">
          <p className="lead text-center">Reasume</p>
          <p className="text-center">
            <img src="./images/pdf.png" alt="" style={{ maxWidth: '75px' }} />
          </p>
          <p className="text-center">
            <button className="btn btn-sm btn-secondary-outline" onClick={() => alert('TODO: Implement file storage...')}>
              download
            </button>
          </p>
        </div>
      </div>
    </>
  );
};

export default Sumary;
